
import confirm from './confirm'
import actions from './actions'
import edit from './edit'

 export default {
	 modules: {
		 confirm,
		 actions,
		 edit
	 },

	 namespaced: true
 };



// WEBPACK FOOTER //
// ./src/store/modules/dialogue/index.js